import request from "@/utils/request";
const apiPath = "/meet/meetingSignUp";
import { downloadBlob } from "@/utils/download";
const meetingSignUpApi = {
  /**
   * 新增【会议报名】
   */
  create(data) {
    return request.post(apiPath + "/tee/save", data);
  },
  /**
   * 新增【会议报名-V2】
   */
  createV2(data) {
    return request.post(apiPath + "/teev2/save", data);
  },
  meetingSignIn(data) {
    return request.post(apiPath + "/tee/signIn", data);
  },
  /**
   * 修改【会议报名】
   */
  update(data) {
    return request.put(apiPath + "/tee/update", data);
  },
  updatePutStay(data) {
    return request.put(apiPath + "/tee/putStay", data);
  },
  /**
   * 分页查询【会议报名】
   */
  fetchList(query) {
    return request.get(apiPath + "/teev2/list", { params: query });
  },
  fetchMeeting(query) {
    return request.get(apiPath + "/tee/listForMini", { params: query });
  },
  getStatusCount(query) {
    return request.get(apiPath + "/tee/getCount", { params: query });
  },
  cancelMeeting(data) {
    return request.post(apiPath + "/teev2/cancel", data);
  },
  /**
   * 查询【会议报名】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query });
  },
  /**
   * 查看【会议报名】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`);
  },
  /**
   * 删除单个【会议报名】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`);
  },
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids });
  },
  exportExcel(query) {
    return request
      .get(`${apiPath}/export`, { responseType: "blob", params: query })
      .then(res => downloadBlob(res, "会议报名列表.xlsx"));
  },
  /**
   * 获取数量-费用 · 单个用户资料
   */
  getCountFeeByUserInfo(query) {
    return request.get(`${apiPath}/tee/getCountFeeByUserInfo`, {
      params: query
    });
  },
  importName(data) {
    return request.post(apiPath + "/teev2/import", data);
  },
  meetingExport(query) {
    return request.get(`${apiPath}/teev2/export`, { params: query });
  },
  downloadExcelTemplate(query) {
    return request
      .get(`${apiPath}/teev2/downloadExcelTemplate`, {
        responseType: "blob",
        params: query
      })
      .then(res => downloadBlob(res, "名单模版.xlsx"));
  },
  /**
   * 支付凭证审核通过
   */
  auditPass(data) {
    return request.post(`${apiPath}/teev2/payVouchers/auditPass`, data);
  },
  /**
   * 支付凭证审核拒绝
   */
  auditReject(data) {
    return request.post(`${apiPath}/teev2/payVouchers/auditReject`, data);
  },
  /**
   * 分页查询【支付凭证审核列表】
   */
  listPayVouchersAudit(query) {
    return request.get(`${apiPath}/teev2/listPayVouchersAudit`, {
      params: query
    });
  },
  /**
   * 赠送金额明细·预估的
   */
  giftAmountDetailEstimate(id) {
    return request.get(`${apiPath}/teev2/giftAmountDetail/estimate/${id}`);
  },
  /**
   * 转票
   */
  transferTicket(data) {
    return request.post(`${apiPath}/teev2/transfer`, data);
  },
  /**
   * 获取转票记录
   */
  fetchTransferRecord(query) {
    return request.get(`${apiPath}/teev2/transferRecord`, { params: query });
  },
  /**
   * 同步报名信息至DXIOT（POST body 为 raw，仅传 meetingId 数值，Content-Type: application/json）
   */
  syncToDXIOT(meetingId) {
    return request.post(`${apiPath}/teev2/syncToDXIOT`, meetingId, {
      headers: { "Content-Type": "application/json" }
    });
  }
};
export default meetingSignUpApi;
